import { render, staticRenderFns } from "./BotaoLaudos.vue?vue&type=template&id=4385c97c&lang=pug"
import script from "./BotaoLaudos.vue?vue&type=script&lang=js"
export * from "./BotaoLaudos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports